import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { BaseService } from 'src/app/shared/services/base.service';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

export interface ILivingComplex {
  id: number,
  name: string,
  isCompleted: boolean,
  disabled?: boolean
}

export interface IUser {
  id?: string;
  email: string;
  lastName: string;
  firstName: string;
  middleName: string;
  mioID: number;
  phoneNumber: string;
  Password?: string;
  ConfirmPassword?: string;
  roles: string[];
  companyID: number;
  departmentID: number;
  lockoutEnabled?: boolean;
  livingComplexes?: string;
  livComplexes?: string[];
  userID: number;
}

export interface IObject {
  infoByRegion: any[];
  objects: ILivingComplex[];
}

export interface IObject2 {
  infoByRegion: any[];
  objects: ILivingComplex[];
}

export interface ILivingComplexUser {
  livingComplexID: number,
  livingComplexTitle: string,
  userID: number,
  userFullName: string,
  roleName: string,
  email: string
}

export interface IUserObjectData {
  name: string;
  id: number;
  email: string;
  anchoredLvComplex: Array<ILivingComplexUser>;
}

let users: IUser[] = [];
let obj: IObject2[] = [];
let comp: ILivingComplex[] = [];
let complexUser: ILivingComplexUser[] = [];

@Injectable({
  providedIn: 'root'
})
export class FgjsService extends BaseService {

  // url = 'https://devbaiterek.idet.kz/objects-hgf-back/LivingComplexes/GetAll';
  // url2 = 'https://devbaiterek.idet.kz/objects-hgf-back/LivingComplexes/GetAllPaginated?pageNumber=1&rowsOfPage=500&statusOfBuildingID=1';
  // url3 = 'https://devbaiterek.idet.kz/widgets-constructor-back/HgfUsers/GetLivingComplexUsers';
  // com: any;
  apiHgf = environment.apiUrlHgf;


  constructor(protected http: HttpClient) {
    super(http);
  }

  saveUsers = new EventEmitter<any>();

  getUsers(): Observable<IUser[]> {
    const url = 'Admin/GetUsers';
    return this.get(url, {}).pipe(map(res => {
      users = res;
      return users;
    }));
  }

  getLivingComplexes(): Observable<ILivingComplex[]> {
    const url = `LivingComplexes/GetAll`;
    return this.get(url, {});
  }

  getLivingComplexes2(): Observable<IObject[]> {
    const url = `${this.apiHgf}LivingComplexes/GetAllPaginated?pageNumber=1&rowsOfPage=500&statusOfBuildingID=1`;
    return this.get(url, {});
  }

  getLivingComplexesPaginated(pageNum: number, rowsOfPage: number) {
    const url = `${this.apiHgf}LivingComplexes/GetAllPaginated?pageNumber=${pageNum}&rowsOfPage=${rowsOfPage}&statusOfBuildingID=1`;
    return this.http.get(url);
    // return this.http.get(`https://devbaiterek.idet.kz/objects-hgf-back/LivingComplexes/GetAllPaginated?pageNumber=${pageNum}&rowsOfPage=${rowsOfPage}&statusOfBuildingID=1`);
  }

  searchLivingComplexesByTitle(searchTerm: string, pageNum: number, rowsOfPage: number) {
    const url = `${this.apiHgf}LivingComplexes/GetAllPaginated?livingComplexTitle=${searchTerm}&pageNumber=${pageNum}&rowsOfPage=${rowsOfPage}`;
    return this.http.get(url);
    // return this.http.get(`https://devbaiterek.idet.kz/objects-hgf-back/LivingComplexes/GetAllPaginated?livingComplexTitle=${searchTerm}&pageNumber=${pageNum}&rowsOfPage=${rowsOfPage}`);
  }

  searchLivingComplexesById(searchTerm: number, pageNum: number, rowsOfPage: number) {
    const url = `${this.apiHgf}LivingComplexes/GetAllPaginated?livingComplexID=${searchTerm}&pageNumber=${pageNum}&rowsOfPage=${rowsOfPage}`;
    return this.http.get(url);
    // return this.http.get(`https://devbaiterek.idet.kz/objects-hgf-back/LivingComplexes/GetAllPaginated?livingComplexID=${searchTerm}&pageNumber=${pageNum}&rowsOfPage=${rowsOfPage}`);
  }

  addComplexUser(userId: number, complexId: number) {
    this.post(`HgfUsers/SetLivingComplexUsers?UserID=${userId}&LivingComplexID=${complexId}`, {}, {observe: 'response'})
        .subscribe(resp => resp);
  }

  getComplexUser(userId: number): Observable<ILivingComplexUser[]> {
    return this.get(`HgfUsers/GetLivingComplexUsers`, { UserID: userId }).pipe(map(res => {
      complexUser = res;
      return complexUser;
    }));
  }

  deleteComplexUser(userId: number) {
    return this.delet(`HgfUsers/DelLivingComplexUsers?UserID=${userId}`, {})
    .then(response => {
      return { status: 200, data: response };
    })
    .catch(error => {
      console.error(error);
      return { status: error.status || 500, error: error };
    });
  }

  deleteComplex(userId: number, complexId: number) {
    return this.delet(`HgfUsers/DelLivingComplexUsers?UserID=${userId}&LivingComplexID=${complexId}`, {})
    .then(response => {
      return { status: 200, data: response };
    })
    .catch(error => {
      console.error(error);
      return { status: error.status || 500, error: error };
    });
  }
}
